export default "__VITE_ASSET__CaT4zGfD__"